module.exports = "/assets/f520f74eb19d3099a6d0372536cb5e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FL.png
// module id = 2499
// module chunks = 0